module.exports = __webpack_public_path__ + "img/reports.66415b8.svg";